import { useEffect, useRef, useState } from "react";
import { useMap } from "react-leaflet";
import * as L from "leaflet";
import * as Esri from "esri-leaflet";

import { BASEMAPS_ENTRIES, LEAFLET_LAYER_ICON } from "../basemaps.js";

import MapSelector from "../MapSelector";

const BASEMAPS_INITIAL_STATE = (initialMapLayer) => {
	initialMapLayer = initialMapLayer || "";
	return BASEMAPS_ENTRIES.map(item => {
		const isVisible = item.visible || (initialMapLayer === item.id);
		return {
			...item,
			visible: isVisible,
		}
	});
}

function Component({ initialMapLayer, currentMapLayer }) {

  const map = useMap();
	const mapControlsRef = useRef([]);
	const mapLayersRef = useRef([]);
	//
	const [activeMapLayers, setActiveMapLayers] = useState([...BASEMAPS_INITIAL_STATE(initialMapLayer || 'onemap')]);
  // Map selector
  const [mapSelectorVisible, setMapSelectorVisible] = useState(false);

	const oneMap = () => {
		return map;
	}

  const mapLayers = () => {
    return mapLayersRef.current;
  }

	const mapControls = (value) => {
		if (value) {
			mapControlsRef.current = value;
		}
		return mapControlsRef.current;
	}

	const addMapControl = (mapControl) => {
		mapControls().push(mapControl);
	}

	const addMapLayer = (mapLayer) => {
		mapLayers().push(mapLayer);
	}

  useEffect(() => {
    initMap();
		return destroyMap;
  }, []);

	useEffect(() => {
    syncMapLayers();
	}, [activeMapLayers]);

  const initMap = async () => {
		L.Marker.include({
		  _panOnFocus: function() {} // This fixes Invalid LatLng error when marker is clicked
		});
    // L.esri = await import ("esri-leaflet");
		L.esri = Esri;
		oneMap().attributionControl.setPrefix(atob("PGEgaHJlZj0iaHR0cHM6Ly9yb2Nrc29saWQuc2ciIHRhcmdldD0iX2JsYW5rIj5Sb2Nrc29saWQuc2c8L2E+"));
    await initMapLayers(); 		// Map layers (create only)
    await initMapControls(); 	// Map controls (create & add to map)
		await syncMapLayers();		// Map layers (sync with UI, fallback to default)
  }

	const destroyMap = () => {
		clearMapControls();
		// clearMapLayers();
	}

	// Map Control
	const initMapControls = () => {
		if (false) {
			L.Control.MapControl = L.Control.extend({
				onAdd: function(map) {
					var el = L.DomUtil.create('div', 'd-flex flex-row gap-1');
					el.innerHTML = `<div class='btn btn-light shadow border d-flex flex-row gap-2'><img src=${LEAFLET_LAYER_ICON} width=25 height=25 /><div>Layers</div></div>`;
					el.onclick = (e) => {
						if (e.target.outerText === "Layers") {
							setMapSelectorVisible(true);
						}
					}
					return el;
				},
			});
			const mapControl = new L.Control.MapControl({ position: 'topright' });
			mapControl.addTo(oneMap());
			addMapControl(mapControl);
		}
	}

	const clearMapControls = () => {
		mapControls().forEach(mapControl => {
			mapControl.remove();
		});
		mapControls([]);
	}

	// Map Layers
  const initMapLayers = () => {
  	for (const config of BASEMAPS_ENTRIES) {
  		const params = {
  			url: config.url,
  			attribution: config.attribution,
  			maxZoom: config.maxZoom,
  			minZoom: config.minZoom,
  			label: config.name,
  			pane: config.id,
  		};
  		if (!oneMap().getPane(config.id)) {
  			oneMap().createPane(config.id);
  		}
  		const mapLayer = config.esriLayer
  			? (config.featureType === 'dynamic' ? L.esri.dynamicMapLayer({ ...params, f: 'image' }) : L.esri.tiledMapLayer(params))
  			: L.tileLayer(config.url, params);
			addMapLayer(mapLayer);
  	}
  }

	const syncMapLayers = () => {
		for (const index in activeMapLayers) {
			const { id, visible, opacity } = activeMapLayers[index];
			const layer = mapLayers().find(item => item.options.pane === id);
			if (!layer) { // Layer has not been created, cannot sync
				continue;
			}
			if (visible) {
				const pane = oneMap().getPane(id);
				if (pane) {
					pane.style.zIndex = index;
				}
				if (!oneMap().hasLayer(layer)) {
					oneMap().addLayer(layer);
				}
				layer.setOpacity(opacity);
			}
			else {
				if (oneMap().hasLayer(layer)) {
					oneMap().removeLayer(layer);
				}
			}
		}
	}

  const clearMapLayers = () => {
		mapLayers().forEach(mapLayer => {
			if (map.hasLayer(mapLayer)) {
				map.remove(mapLayer);
			}
		});
		mapLayers([]);
	}

  return (
		<MapSelector
			visible={mapSelectorVisible}
			setVisible={setMapSelectorVisible}
			mapLayers={activeMapLayers}
			setMapLayers={setActiveMapLayers}
		/>
  );

}

export default Component;
